import { Button, DialogContent, Stack, Typography } from '@mui/material';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';

import styles from './DuplicateEmailDialog.module.scss';

export interface DuplicateEmailDialogProps extends DialogProps {
  onConfirm: () => void;
  onClose?: () => void;
}

export function DuplicateEmailDialog({ onClose, onConfirm, ...rest }: DuplicateEmailDialogProps) {
  const { t } = useTranslation('auth');

  return (
    <Dialog {...rest} className={styles.dialog}>
      <DialogContent>
        <Typography component='p' variant='body5'>
          {t('duplicateEmailDialog.messageLine1')}
          <br />
          {t('duplicateEmailDialog.messageLine2')}
        </Typography>

        <Stack direction='row' spacing={'10px'} alignItems='center'>
          <Button variant='outlined' fullWidth className={styles.formButton} onClick={onClose}>
            {t('duplicateEmailDialog.cancel')}
          </Button>
          <Button variant='contained' fullWidth className={styles.formButton} onClick={onConfirm}>
            {t('duplicateEmailDialog.yes')}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
